import React, { createContext, useCallback, useContext, useMemo, useRef } from 'react';

const BrainCanvasContext = createContext({
  register: () => () => {},
  applyPatch: () => {},
  applyClipboard: async () => false,
  undo: () => {},
});

export function BrainCanvasProvider({ children }) {
  const apiRef = useRef({});

  const register = useCallback((api) => {
    apiRef.current = api || {};
    return () => {
      if (apiRef.current === api) apiRef.current = {};
    };
  }, []);

  const applyPatch = useCallback((patch) => {
    apiRef.current.applyPatch?.(patch);
  }, []);

  const applyClipboard = useCallback(async (preview) => {
    return (await apiRef.current.applyClipboard?.(preview)) || false;
  }, []);

  const undo = useCallback(() => {
    apiRef.current.undo?.();
  }, []);

  const value = useMemo(
    () => ({ register, applyPatch, applyClipboard, undo }),
    [register, applyPatch, applyClipboard, undo]
  );
  return <BrainCanvasContext.Provider value={value}>{children}</BrainCanvasContext.Provider>;
}

export function useBrainCanvas() {
  return useContext(BrainCanvasContext);
}
